import React from "react"
import { useFormikContext } from "formik"
import Calendar from "react-calendar"
import { isHoliday } from "poland-public-holidays"
import { useOrder } from "context/order"
import Button from "components/Button"
import ArrowRight from "icons/calendar_right.svg"
import ArrowLeft from "icons/calendar_left.svg"
import StyledStepFourth from "./styles"
import { useLocale } from "context/locale"

const StepFourth = () => {
  const { t, lang } = useLocale()

  const { values, validateForm, errors, isValid, setFieldValue } =
    useFormikContext()
  const { step, setStep, checkValidation } = useOrder()
  const today = new Date()
  return (
    <div className="form-step" style={step !== 4 ? { display: "none" } : {}}>
      <StyledStepFourth>
        <h4 className="order-courier-form__subheader">
          {t("Tell us when you want the courier to pick up the parcel")}
        </h4>
        <div className="order-calendar">
          <div className="order-courier-form__info">
            <p>
              {t(
                "Remember that DPD couriers work only from Monday to Friday, from 9:00 am to 5:00 pm. Some DPD Pickup points are also open on Saturdays."
              )}
            </p>
            <p>
              {t(
                "On the calendar below, mark the day when your cartons will be ready to be picked up by the courier or – if you prefer to hand them over at the DPD Pickup point – when you’ll do it. It will help us prepare to receive your parcel at our warehouse."
              )}
            </p>
          </div>
          <div className="calendar-box">
            {errors?.date && <p className="form-error">{errors.date}</p>}
            <Calendar
              minDate={
                new Date(
                  today.getFullYear(),
                  today.getMonth(),
                  today.getDate() + 1
                )
              }
              locale={lang === "en" ? "en-EN" : "pl-PL"}
              onChange={e => setFieldValue("date", e)}
              prev2Label={null}
              next2Label={null}
              minDetail="month"
              nextLabel={<ArrowRight />}
              prevLabel={<ArrowLeft />}
              value={values.date}
              tileDisabled={({ date }) =>
                date.getDay() === 0 || date.getDay() === 6 || isHoliday(date)
              }
            />
          </div>
        </div>
        <div className="order-courier-form__cta">
          <Button
            type="button"
            text={t("Back")}
            variant="prev"
            onClick={() => setStep(3)}
          />
          <Button
            type="button"
            text={t("Next")}
            variant="next"
            disabled={!isValid}
            onClick={async () => {
              if (checkValidation(await validateForm())) {
                setStep(5)
              }
            }}
          />
        </div>
      </StyledStepFourth>
    </div>
  )
}
export default StepFourth
